/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "components/generals/Button";
import { RoutesConstants } from "@malmur-technologies/medicalsystem-shared";
import ErrorIcon from "@mui/icons-material/Error";
import Card from "components/generals/Card";
import Typography from "components/generals/Typography";
import Box from "components/generals/Box";

interface PasswordRecoveryCard {
  title: string;
  description?: string;
  error?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  timer?: React.ReactNode;
}

const PasswordRecoveryCard = ({
  title,
  description,
  error,
  children,
  footer,
  timer,
}: PasswordRecoveryCard) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card className="password-recovery-card">
      <CardContent className="card-content">
        <Typography variant="h5" className="title">
          {title}
        </Typography>
        {description && (
          <Typography variant="caption" className="description">
            {description}
          </Typography>
        )}

        {children}

        {error && (
          <Box className="error">
            <ErrorIcon className="error-icon" />
            {error}
          </Box>
        )}

        <Box className="footer">
          {timer}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate(RoutesConstants.LOGIN)}
          >
            {t("passwordRecovery.cancel")}
          </Button>
          {footer}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PasswordRecoveryCard;
